// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5273":"eb14a946b22b0708","7160":"b6ac5fd857728a90"}[chunkId] + ".js";
};